import { Component, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BasePageComponent } from '../../base-page/base-page.component';
import { Mission, MissionPrize } from 'src/app/services/missions/missions.models';
import { MissionDetailsService } from 'src/app/services/missions/mission-details.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { MainMissionComponent } from '../main-mission/main-mission.component';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { Router } from '@angular/router';
import { gameInfoTrx, launchGameTrx } from 'src/app/router-translation.labels';
import { UserInfoService } from 'src/app/services/auth/check-session/user-info.service';

@Component({
  selector: 'app-mission-prizes',
  templateUrl: './mission-prizes.component.html',
  styleUrls: ['./mission-prizes.component.scss']
})
export class MissionPrizesComponent extends BasePageComponent {

  constructor(
    public dialogRef: MatDialogRef<MainMissionComponent>,
    public detectDesktopService: DetectDeviceService,
    protected translationConfig: TranslationConfig,
    public router: Router,
    public userInfoService: UserInfoService,
    protected missionDetails: MissionDetailsService,
    protected licenceService: LicenceService,
  ) { super() }

  @Input() mission: Mission;
  prize: MissionPrize;

  getDetails() {
    this.missionDetails.getMissionPrizes(this.mission?.cmsId).pipe(
      takeUntil(this.unsubscribe)
    ).subscribe((prize) => {
      this.prize = prize;
      console.log('prizes', this.mission, this.prize)
    })
  }

  ngOnInit(): void {
    this.getDetails();
  }

  launchGame(gameId, gameName) {
    if (this.detectDesktopService.isDesktop()) {
      this.router.navigate(["", this.translationConfig.getTranslation(gameInfoTrx), gameName]).then(() => {
        this.closeDialog();
      });

    }
    else {
      this.router.navigate([this.translationConfig.getTranslation(launchGameTrx), gameId], { skipLocationChange: true }).then(() => {
        this.closeDialog();
        this.userInfoService.openChat();
      });
    }
    // this.router.navigate(['/'+launcgGameTrx+'/'+this.data.gameid]);
  }

  closeDialog() {
    this.dialogRef?.close(false);
  }

}
